import {INotificationsResponse} from './interfaces';
import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';

export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const APPEND_NOTIFICATIONS = 'APPEND_NOTIFICATIONS';
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const MARK_ALL_NOTIFICATIONS_READ = 'MARK_ALL_NOTIFICATIONS_READ';
export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS';
export const SET_NOTIFICATION_COUNT = 'SET_NOTIFICATION_COUNT';

export const setNotifications = (response: INotificationsResponse): IAction<INotificationsResponse> => ({
  type: SET_NOTIFICATIONS,
  payload: response
});

export const appendNotifications = (response: INotificationsResponse): IAction<INotificationsResponse> => ({
  type: APPEND_NOTIFICATIONS,
  payload: response
});

export const markNotificationRead = (notifId: number): IAction<number> => ({
  type: MARK_NOTIFICATION_READ,
  payload: notifId
});

export const markAllNotificationsRead = (): IAction<null> => ({
  type: MARK_ALL_NOTIFICATIONS_READ,
  payload: null
});

export const resetNotifications = (): IAction<null> => ({
  type: RESET_NOTIFICATIONS,
  payload: null
});

export const setNotificationCount = (count: number): IAction<number> => ({
  type: SET_NOTIFICATION_COUNT,
  payload: count
});

const notificationActions = {
  setNotifications,
  appendNotifications,
  markNotificationRead,
  markAllNotificationsRead,
  resetNotifications,
  setNotificationCount
};

export type NotificationActionsType = InferActionsTypes<typeof notificationActions>;
